import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column mb-9 fv-row" }
const _hoisted_2 = ["value", "label"]
const _hoisted_3 = { class: "d-flex justify-content-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_6 = { key: 1 }

import { ref, onMounted } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import { Field } from "vee-validate";
import UserService from "../../services/UserService";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";
import { ElNotification } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeSiteModal',
  emits: ["updateSiteID"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(false);
const modalForm = ref<InstanceType<typeof SimpleForm>>();
const partyId = ref();
const siteId = ref();



const updateSiteId = async () => {
  isLoading.value = true;
  try {
    await UserService.updateSiteID(partyId.value, siteId.value);
    ElNotification.success("Update Site ID successfully");
    emits("updateSiteID", siteId.value);
    modalForm.value?.hide();
  } catch (error) {
    ElNotification.error({
      title: "Error",
      message: error.message,
    });
  } finally {
    isLoading.value = false;
  }
};

__expose({
  async show(_partyId: any, _siteId: any) {
    modalForm.value?.show();
    partyId.value = _partyId;
    siteId.value = _siteId;
  },
  hide() {
    modalForm.value?.hide();
  },
});

onMounted(() => {
  // console.log(SiteTypes);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SimpleForm, {
      ref_key: "modalForm",
      ref: modalForm,
      title: _ctx.$t('fields.changeUserSiteId'),
      "is-loading": isLoading.value,
      "disable-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(Field), {
            name: "serviceCurrencyId",
            class: "form-select form-select-solid",
            as: "select",
            modelValue: siteId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((siteId).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (site) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: site.value,
                  value: site.value,
                  label: site.label
                }, null, 8, _hoisted_2))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-light btn-success btn-md me-3",
            onClick: updateSiteId
          }, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.waiting")) + " ", 1),
                  _hoisted_5
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("action.update")), 1))
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "is-loading"])
  ]))
}
}

})